<template>
  <article>
    <div class="flex flex-1 fw jcb mt-20">
      <div class="flex flex-1 aic">
        <div class="form-item">用户昵称：</div>
        <div class="flex-1">{{detail.nickname}}({{detail.euid}})</div>
      </div>
      <div class="flex flex-1 aic">
        <div class="form-item">头像：</div>
        <div class="flex-1">
          <img :src="detail.headimgurl" width="60" height="60">
        </div>
      </div>
      <div class="flex flex-1 aic">
        <div class="form-item">账号：</div>
        <div class="flex-1">{{detail.phone}}</div>
      </div>
      <div class="flex flex-1 aic">
        <div class="form-item">注册时间：</div>
        <div class="flex-1" v-html="formatTimeStamp(detail.create_time, false)"></div>
      </div>
    </div>
    <div class="flex flex-1 fw jcb mt-20">
      <div class="flex flex-1 aic">
        <div class="form-item">支付宝账号：</div>
        <div class="flex-1">{{detail.alipay}}</div>
      </div>
      <div class="flex flex-1 aic">
        <div class="form-item">真实名字：</div>
        <div class="flex-1">{{detail.alipay_name}}</div>
      </div>
      <div class="flex flex-1 aic">
        <div class="form-item">师傅：</div>
        <div class="flex-1">
          <router-link :to="{path: '/earnUserDetail', query: {euid: detail.father}}">{{detail.father_nickname}}({{detail.father}})</router-link>
        </div>
      </div>
      <div class="flex flex-1 aic">
        <div class="form-item">状态：</div>
        <div class="flex-1" v-if="detail.status === 1">正常</div>
        <div class="flex-1" v-if="detail.status === 0">封杀</div>
      </div>
    </div>
    <div class="base mt-30">
      <div class="base__container">
        <div v-for="(item, index) in baseList" class="base__item" :key="index">
          <div class="base__name">{{item.name}}</div>
          <div class="base__value">{{item.value}}</div>
        </div>
      </div>
    </div>
    <div class="mt-20 fc-blue fs-16">收入明细</div>
    <el-table :data="userTaskList" highlight-current-row v-loading="userAdLoading" class="mt-20">
      <el-table-column prop="trid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="source" label="来源" width="">
        <template slot-scope="scope">
          <div v-if="scope.row.source === 1">邀请</div>
          <div v-if="scope.row.source === 2">徒弟下单</div>
          <div v-if="scope.row.source === 3">提现</div>
        </template>
      </el-table-column>
      <el-table-column prop="srid" label="来源ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="from_euid" label="来源用户" width="">
        <template slot-scope="scope">
          <div v-if="scope.row.from_euid">
            <div>{{scope.row.from_nickname}}({{scope.row.from_euid}})</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" width="" align="center">
      </el-table-column>
      <el-table-column prop="income" label="收入" width="" align="center">
      </el-table-column>
      <el-table-column prop="cost" label="支出" width="" align="center">
      </el-table-column>
      <el-table-column prop="balance" label="完成任务后余额" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleTaskRecordSizeChange" @current-change="handleTaskRecordCurrentChange" :page-size="userTaskFilters.l" :page-sizes="[20, 50, 80, 100]" :total="userTaskFilters.total" :current-page="userTaskFilters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <div class="mt-20 fc-blue fs-16">订单明细</div>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">广告：</div>
        <el-select class="filter__input" size="mini" v-model="checkFilters.adid">
          <el-option :label="item.title" :value="item.adid" v-for="(item, index) in taskLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="checkFilters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="earnOrderLists">搜索</button>
    </div>
    <el-table :data="orderList" highlight-current-row v-loading="checkloading" height="600" class="mt-20">
      <el-table-column prop="eoid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="euid" label="用户" width="" align="center" sortable>
        <template slot-scope="scope">
          <div>{{scope.row.username}}({{scope.row.euid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="广告" width="">
        <template slot-scope="scope">
            <div>{{scope.row.title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderid" label="订单ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="nickname" label="微信昵称" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment" label="金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="min_discount" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
            <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="discount" label="项目折扣" width="" align="center">
        <template slot-scope="scope">
            <div>{{scope.row.discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="commission" label="佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment_img" label="报单截图" width="" align="center">
        <template slot-scope="scope">
          <div @click="previewURL(scope.row.eoid, 0)">
            <img :src="scope.row.payment_img" style="width:60px;height:80px;" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="finish_img" label="完成截图" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.finish_img" @click="previewURL(scope.row.eoid, 2)">
            <img :src="scope.row.finish_img" style="width:60px;height:80px;" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 6">拒绝</div>
          <div v-if="scope.row.status == 5">失效</div>
          <div v-if="scope.row.status == 4">已提现</div>
          <div v-if="scope.row.status == 3">返款中</div>
          <div v-if="scope.row.status == 2">完成订单</div>
          <div v-if="scope.row.status == 1">跟单中</div>
          <div v-if="scope.row.status == 0">报单</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleOrderSizeChange" @current-change="handleOrderCurrentChange" :page-size="checkFilters.l" :page-sizes="[20, 50, 80, 100]" :total="checkFilters.total" :current-page="checkFilters.p" class="tac mt-36 pb-36">
    </el-pagination>

    <el-dialog :visible.sync="previewDialog">
      <el-carousel type="card" :autoplay="false" height="500px">
        <el-carousel-item v-for="item in previewList" :key="item">
<!--          <img :src="item" height="400">-->
          <el-image
            style="height: 500px"
            :src="item"
            fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

  </article>
</template>

<script>
import util from '../../../script/util'
import {earnUserDetail, taskLists, earnOrderLists, earnUserTaskRecordLists} from '../../../api/api'
export default {
  name: 'earnUserDetail',
  data () {
    return {
      baseList: [
        { name: '余额', ename: 'balance', value: 0 },
        { name: '收入', ename: 'income', value: 0 },
        { name: '支出', ename: 'cost', value: 0 },
        { name: '奖励师傅', ename: 'f_commission', value: 0 },
        { name: '接单广告数', ename: 'ad_number', value: 0 },
        { name: '总订单数', ename: 'ocount', value: 0 },
        { name: '总金额', ename: 'payment', value: 0 },
        { name: '总佣金', ename: 'commission', value: 0 },
        { name: '丢单数', ename: 'invalid_num', value: 0 },
        { name: '打款订单数', ename: 'exchange_order', value: 0 },
        { name: '打款金额', ename: 'exchange_payment', value: 0 },
        { name: '打款佣金', ename: 'exchange_amount', value: 0 }
      ],
      detail: {
        headimgurl: '',
        nickname: '',
        euid: ''
      },
      previewDialog: false, // 查看图片弹窗
      previewList: [], // 查看列表
      userTaskList: [],
      userTaskLoading: false,
      userTaskFilters: {
        p: 1,
        l: 20,
        total: 0
      },
      orderList: [],
      checkloading: false,
      checkFilters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        status: ''
      },
      taskLists: [],
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '报单',
          value: 0
        },
        {
          name: '跟单中',
          value: 1
        },
        {
          name: '完成订单',
          value: 2
        },
        {
          name: '提现中',
          value: 3
        },
        {
          name: '已提现',
          value: 4
        },
        {
          name: '丢单',
          value: 5
        }
      ]
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time, br = true) {
      return util.formatTimeStamp(time, br)
    },
    handleTaskRecordSizeChange (val) {
      this.userTaskFilters.l = val
      this.earnUserTaskRecordLists()
    },
    handleTaskRecordCurrentChange (val) {
      this.userTaskFilters.p = val
      this.earnUserTaskRecordLists()
    },
    previewURL (eoid, status) {
      let images = []
      let initialViewIndex = 0
      this.orderList.forEach((item) => {
        if (status === 0) {
          if (item.payment_img !== '') {
            images.push(item.payment_img)
          }
        } else {
          if (item.finish_img !== '') {
            images.push(item.finish_img)
          }
        }
        if (item.eoid === eoid) {
          initialViewIndex = images.length - 1
        }
      })

      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: initialViewIndex
        },
        images: images
      })
    },
    earnUserDetail () {
      let params = {
        euid: this.detail.euid
      }
      this.loading = true
      earnUserDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d
          this.baseList.forEach((item) => {
            item.value = this.detail[item['ename']]
          })
        }
        this.loading = false
      })
    },
    earnUserTaskRecordLists () {
      let filters = this.userTaskFilters
      let params = {
        euid: this.detail.euid,
        p: filters.p,
        l: filters.l
      }

      earnUserTaskRecordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.userTaskList = data.d.lists
          this.userTaskFilters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      })
    },
    getTaskLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid
            }
          })
          this.taskLists.unshift({
            title: '所有',
            adid: ''
          })
        }
      })
    },
    handleOrderSizeChange (val) {
      this.checkFilters.l = val
      this.earnOrderLists()
    },
    handleOrderCurrentChange (val) {
      this.checkFilters.p = val
      this.earnOrderLists()
    },
    earnOrderLists () {
      let filters = this.checkFilters
      let params = {
        euid: this.detail.euid,
        p: filters.p,
        l: filters.l
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      this.listLoading = true
      earnOrderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.orderList = data.d.lists
          this.checkFilters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    preview (index) {
      this.previewDialog = true
      this.previewList = this.orderList[index].screenshot
    }
  },
  mounted () {
    this.detail.euid = parseInt(this.$route.query.euid || 0)
    if (this.detail.euid) {
      this.earnUserDetail()
      this.earnUserTaskRecordLists()
      this.getTaskLists()
      this.earnOrderLists()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../style/color";
  .dataForm{
    border: 1px solid #e5e5e5;
    padding: 10px;
    border-radius: 10px;
    &__name{
      color: $blue;
      font-weight: bold;
    }
  }
  .base{
    &__container{
      display: flex;
      flex-wrap: wrap;
    }
    &__item{
      width: calc((100% - 20px * 3) / 4);
      text-align: center;
      box-sizing: border-box;
      border: 1px solid #e5e5e5;
      padding: 15px 0;
      border-radius: 10px;
      margin: 0 20px 20px 0;
      &:nth-of-type(4n){
        margin-right: 0;
      }
    }
    &__value{
      font-size: 24px;
      font-weight: 700;
      margin-top: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnUserDetail.vue